import React from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import {
  PaginationItem, 
  PaginationLink
} from 'reactstrap';

const Pager = ({ baseUrl, active, disabled, page, prev, next }) => {

  const prevTemplate = () => {
    return (
      <React.Fragment>
          <span aria-hidden="true">«</span><span className="sr-only">Previous</span>
      </React.Fragment>
    )
  }

  const nextTemplate = () => {
    return (
      <React.Fragment>
          <span aria-hidden="true">»</span><span className="sr-only">Next</span>
      </React.Fragment>
    )
  }
  const link = page => () => {
    let children = null;
    if (prev) {
      children = prevTemplate();
    }

    if (next) {
      children = nextTemplate();
    }

    return (
      <Link className="page-link" to={`${ baseUrl }?page=${ page }`}>{ children || page }</Link>
    );
  }
  
  return (
    <PaginationItem 
      key={ page } 
      active={ active }
      disabled={ disabled }
    >
      <PaginationLink tag={ link(page) } />
    </PaginationItem>
  );
}

Pager.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  prev: PropTypes.bool,
  next: PropTypes.bool,
  baseUrl: PropTypes.string,
  page: PropTypes.number
};

// Same approach for defaultProps too
Pager.defaultProps = {
  baseUrl: '/url',
};

export default Pager;



// WEBPACK FOOTER //
// ./src/views/Components/Pagination/Pager.js